import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import CheckboxSettingsField from './CheckboxSettingsField';
import { StyledFieldWrapper } from './SettingsCommonElements';

import { resolveEditability } from '../../../lib/tableHelper';
import TableEditabilityTypes from '../../../constants/TableEditabilityTypes';
import ThemeIcons from '../../../theme/Icons';
import ThemeContext from '../../../theme/ThemeContext';

/**
 * Builder control for the `editability` of a table field or a collection schema.
 *
 * Two checkboxes, one per token. The checked state comes from resolveEditability, so an empty,
 * missing or unrecognised stored value shows both boxes checked, the same way it behaves in fill
 * mode. Every change writes an explicit array. The last checked box is disabled: unchecking it
 * would store [], which means both, and the author would see both come back checked.
 */
const EditabilitySettings = ({ id, editability, onChange }) => {

  const theme = useContext(ThemeContext);

  const { inline, form } = resolveEditability(editability);

  const handleChange = (nextInline, nextForm) => {
    const next = [];
    if (nextInline) next.push(TableEditabilityTypes.inline);
    if (nextForm) next.push(TableEditabilityTypes.form);
    if (next.length === 0) return;
    onChange(next);
  };

  return (
    <>
      <StyledFieldWrapper>
        <CheckboxSettingsField
          icon={ThemeIcons.fields.table}
          iconColor={inline ? theme.primaryColor : theme.borderColor}
          id={`${id}-editability-inline`}
          label="Edit in table"
          selected={inline}
          disabled={inline && !form}
          onChange={(selected) => handleChange(selected, form)}
        />
      </StyledFieldWrapper>
      <StyledFieldWrapper>
        <CheckboxSettingsField
          icon={ThemeIcons.settings.edit}
          iconColor={form ? theme.primaryColor : theme.borderColor}
          id={`${id}-editability-form`}
          label="Edit in row form"
          selected={form}
          disabled={form && !inline}
          onChange={(selected) => handleChange(inline, selected)}
        />
      </StyledFieldWrapper>
    </>
  );

};

EditabilitySettings.propTypes = {
  id: PropTypes.string,
  editability: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

export default EditabilitySettings;
